import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/lib/supabase";

export interface VisionMisionDB {
  id: number;
  tipo: "vision" | "mision";
  titulo: string;
  descripcion: string;
  icono: string;
  orden: number;
  created_at: string;
}

export function useVisionMision() {
  const [data, setData] = useState<VisionMisionDB[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data: result, error: err } = await supabase
        .from("vision_mision")
        .select("*")
        .order("orden", { ascending: true });
      if (err) throw err;
      setData(result as VisionMisionDB[] ?? []);
    } catch {
      setError("Error cargando visión y misión");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}